import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { useEventLogging } from '../../../../models/Logging';
import { useReportsContactByEntityQuery } from '../../../../queries';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../../../components-v2/Select';
import { LoadingSpinner } from '../../LoadingSpinner';
import { styleSheet } from './styles';

const TimespanOptions = [180, 90, 60, 30].map(x => ({
	dataContext: x,
	id: `timespan-option-${x}`,
	text: `${x} days`,
}));

export function ContactAnalysisHeader({ contactId }: { contactId: string }) {
	const userSession = useUserSession();
	const { logInput } = useEventLogging('ContactAnalysisHeader');
	const [selectedTimespanInDays, setSelectedTimespanInDays] = React.useState(TimespanOptions[0].dataContext);
	const reportsContactByEntityQuery = useReportsContactByEntityQuery({
		endDate: moment().endOf('day').toISOString(),
		entityId: contactId,
		startDate: moment().subtract(selectedTimespanInDays, 'days').startOf('day').toISOString(),
	});

	const renderActivityMetric = (title: string, resourceActivity: Api.IResourceActivity | null) => {
		return (
			<div className={css(styleSheet.statsTableMetric)}>
				<div className={css(styleSheet.statsTableMetricTitle)}>{title}</div>
				<div className={css(styleSheet.statsTableMetricValue)}>
					{!resourceActivity ? <span>&nbsp;</span> : resourceActivity.count}
				</div>
			</div>
		);
	};
	const renderStatsTable = () => {
		return (
			<div className={css(styleSheet.statsTable)}>
				<div className={css(styleSheet.statsTableContent)}>
					{renderActivityMetric('notes', reportsContactByEntityQuery.data?.currentPeriod?.notes)}
					{renderActivityMetric('actions', reportsContactByEntityQuery.data?.currentPeriod?.actionItems)}
					{userSession.user.emailProviderFeatures?.email?.canViewHistoryByContact
						? renderActivityMetric('emails', reportsContactByEntityQuery.data?.currentPeriod?.emailsSent)
						: null}
					{userSession.user.emailProviderFeatures?.calendar?.canViewHistoryAll
						? renderActivityMetric('meetings', reportsContactByEntityQuery.data?.currentPeriod?.meetings)
						: null}
				</div>
			</div>
		);
	};
	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.title)}>
				<span className={css(styleSheet.titleText)}>Overview</span>
				<div className={css(styleSheet.timeSpanFilter)}>
					<span>Showing:</span>
					<Select
						value={TimespanOptions.find(x => x.dataContext === selectedTimespanInDays)?.id}
						onValueChange={id => {
							const opt = TimespanOptions.find(x => x.id === id);
							if (opt && opt.dataContext !== selectedTimespanInDays) {
								logInput('SetTimeSpan', 'Click', { timeSpan: opt.dataContext });
								setSelectedTimespanInDays(opt.dataContext);
							}
						}}
					>
						<SelectTrigger styles={[styleSheet.timeSpanFilterSelect]}>
							{TimespanOptions.find(x => x.dataContext === selectedTimespanInDays)?.text}
						</SelectTrigger>
						<SelectContent>
							{TimespanOptions.map(opt => (
								<SelectItem key={opt.id} value={opt.id}>
									{opt.text}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</div>
			</div>
			{renderStatsTable()}
			{reportsContactByEntityQuery.isPending ? (
				<LoadingSpinner type='large' className={`absolute-center ${css(styleSheet.loading)}`} />
			) : null}
		</div>
	);
}
